import { z } from '@/utils/zod'

export const defaultLightThemeColors = {
    accent: '#0074BD',
    pageBackground: '#F3F4F6',
    surfaceBackground: '#FFFFFF',
} as const

export const defaultDarkThemeColors = {
    accent: '#018BCC',
    pageBackground: '#141A1F',
    surfaceBackground: '#192128',
} as const

export const ThemeColorsSchema = z.object({
    accent: z.hexColor(),
    pageBackground: z.hexColor(),
    surfaceBackground: z.hexColor(),
})

export type ThemeColors = z.infer<typeof ThemeColorsSchema>
